import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserState } from '../interface/MyInterfaces';

//import Logout from './Logout';


export function Heading(props) {
    return (
        <div style={{paddingTop: 15}}>
            <h1>{props.value}</h1>
        </div>
    )
}

interface NavMenuProps {
    collapsed?: any;
    toggleNavbar?();
    UserState?: UserState;
}

export class NavMenu extends React.Component<NavMenuProps, {}> {
    constructor(props) {
        super(props);
        
    }
    

    public render() {
        const collapsed = this.props.collapsed;
        const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
        const classTwo = collapsed ? 'navbar-toggler' : 'navbar-toggler navbar-toggler-expand';
        const classThree = collapsed ? 'shrink' : '';
        const classFour = collapsed ? 'right' : 'left';

        return <div className={`main-nav ${classThree}`}>

            <a href="https://iris.isr.umich.edu" target="_blank"><img className="main-nav-logo" height='80px' src={require('../images/IRISLogo_Portal.png')} alt='Logo'></img></a>
           
            <div className='navbar'>
                    <div className="collapse navbar-collapse" id="collapsibleNavbar">

                    <button onClick={this.props.toggleNavbar} className={`${classTwo}`} type="button" data-toggle="collapse" data-target="#collapsibleNavbar" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        <span className={`fa fa-angle-double-${classFour}`}></span>
                    </button>



                    <ul className='nav navbar-nav'>
                        <li>
                            <NavLink title='Dashboard' to={'/dashboard'} exact>
                                <span className='glyphicon glyphicon-dashboard'></span>{!this.props.collapsed && ` Dashboard`}
                            </NavLink>
                            </li>
                            <li>
                                <NavLink title='Submissions' to={'/submissions'}>
                                <span className='glyphicon glyphicon-open-file'></span>{!this.props.collapsed && ` Submissions`}
                            </NavLink>
                            </li>
                            <li>
                                <NavLink title='Reports' to={'/reports'}>
                                <span className='glyphicon glyphicon-stats'></span>{!this.props.collapsed && ` Reports`}
                            </NavLink>
                        </li>
                        {this.props.UserState.username == "testadmin@umich.edu" &&
                            <li>
                                <NavLink title='Benchmarking' to={'/benchmarking'}>
                                    <span className='glyphicon glyphicon-stats'></span>{!this.props.collapsed && ` Benchmarking`}
                                </NavLink>
                            </li>
                        }
                            <li>
                                <NavLink title='Manage Users' to={'/manageusers'}>
                                <span className='glyphicon glyphicon-user'></span>{!this.props.collapsed && ` Manage Users`}
                            </NavLink>
                            </li>
                            <li>
                                <NavLink title='Downloads' to={'/downloads'}>
                                <span className='glyphicon glyphicon-list'></span>{!this.props.collapsed && ` Documents`}
                            </NavLink>
                            </li>
                            <li>
                                {
                                    this.props["qa_account"] === "Y" &&
                                    <NavLink title='Admin' to={'/admin/member_management'}>
                                    <span className='glyphicon glyphicon-wrench'></span>{!this.props.collapsed && ` Admin`}
                                    {/*<ul className="menu_sub">
                                        <li><NavLink to={'/admin/member_management'}><span className='glyphicon glyphicon-link'></span>{!this.props.collapsed && `Member Management`}</NavLink></li>
                                        <li><NavLink to={'/admin/research'}><span className='glyphicon glyphicon-eye-open'></span>{!this.props.collapsed && `Research Team`}</NavLink></li>
                                        <li><NavLink to={'/admin/node_interface'}><span className='glyphicon glyphicon-tasks'></span>{!this.props.collapsed && `Node Interface`}</NavLink></li>
                                        </ul>*/}
                                    </NavLink>
                                }

                            </li>
                            <li>
                                <NavLink title='Help' to={'/help'}>
                                <span className='glyphicon glyphicon-earphone'></span>{!this.props.collapsed && ` Help + Support`}
                            </NavLink>
                            </li>
                        <li>
                            {/*<Logout collapsed={this.props.collapsed} />*/}
                            </li>

                        </ul>
                    </div>
                </div>
            
        </div>;
    }
}

